/**
 * @description Removes duplicate strings from an array of strings.
 * @param arr - Array of strings.
 * @returns A new array with duplicate strings removed.
 */
export default function dedupeArray(arr: readonly string[]): readonly string[] {
  const seen: Record<string, boolean> = {}
  return arr.filter((item: string) =>
    Object.hasOwn(seen, item) ? false : (seen[item] = true)
  )
}
